import { render, staticRenderFns } from "./FButton.vue?vue&type=template&id=ad031132&scoped=true&"
import script from "./FButton.vue?vue&type=script&lang=js&"
export * from "./FButton.vue?vue&type=script&lang=js&"
import style0 from "./FButton.vue?vue&type=style&index=0&id=ad031132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.3_r_gaeimbjcwu57yzcey4waijeptq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad031132",
  null
  
)

export default component.exports